module.exports = __webpack_public_path__ + "static/media/cart_summary_icon.8b926091.svg";